const initVuexState = function(state) {
    state.gameBanners = {
        // uncomment if u need game banners 
        // 'MBK777': [
        //     {
        //         'category': 'crash',
        //         'img': '/static/banners/game-banners/banner.jpg',
        //         'game': {
        //             'provider': 'redpipe',
        //             'gameId': 'mine-field'
        //         }
        //     },
        //     {
        //         'category': 'fast',
        //         'img': '/static/banners/game-banners/banner.jpg',
        //         'game': {
        //             'provider': 'redpipe',
        //             'gameId': 'mine-field'
        //         }
        //     },
        //     {
        //         'category': 'races',
        //         'img': '/static/banners/game-banners/banner.jpg',
        //         'game': {
        //             'provider': 'redpipe',
        //             'gameId': 'mine-field'
        //         }
        //     },
        //     {
        //         'category': 'slots',
        //         'img': '/static/banners/game-banners/banner.jpg',
        //         'game': {
        //             'provider': 'redpipe',
        //             'gameId': 'mine-field'
        //         }
        //     }
        // ]
    };
};

const initGetters = function(getters) {
    getters.allGameBanners = state => state.gameBanners;
    getters.gameBanner = state => (client, category) => {
        return state.gameBanners[client] && state.gameBanners[client].find(g => g.category === category);
    };
};

const initActions = function(actions) {};

const initMutations = function(mutations) {};

const initAppState = function(appState, store) {
    appState.gameBanners = {
        get: (client, category) => store.getters.gameBanner(client, category),
        getAllBanners: () => store.getters.allGameBanners,
    }
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};


// WEBPACK FOOTER //
// ./skins/bulmasite/data/game-banners.js